(function () {
  var CACHE_TTL_MS = 10 * 60 * 1000;
  var initializedBadges = new WeakSet();

  function setHidden(element, hidden) {
    if (!element) return;
    if (hidden) element.setAttribute('hidden', 'hidden');
    else element.removeAttribute('hidden');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderStars(rating) {
    var rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return '★★★★★'.slice(0, rounded) + '☆☆☆☆☆'.slice(0, 5 - rounded);
  }

  function formatCount(value) {
    var numberValue = Number(value);
    if (!Number.isFinite(numberValue)) return String(value || '');
    return numberValue.toLocaleString();
  }

  function extractReviewsPayload(payload) {
    if (!payload) return { reviews: [] };
    if (Array.isArray(payload)) return { reviews: payload };
    if (Array.isArray(payload.reviews)) return payload;
    if (payload.result && Array.isArray(payload.result.reviews)) return payload.result;
    if (payload.data && Array.isArray(payload.data.reviews)) return payload.data;
    return { reviews: [] };
  }

  function readCachedPayload(cacheKey) {
    try {
      if (!window.sessionStorage) return null;
      var raw = window.sessionStorage.getItem(cacheKey);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (!cached || !cached.savedAt || !cached.payload) return null;
      if (Date.now() - cached.savedAt > CACHE_TTL_MS) {
        window.sessionStorage.removeItem(cacheKey);
        return null;
      }
      return cached.payload;
    } catch (e) {
      return null;
    }
  }

  function writeCachedPayload(cacheKey, payload) {
    try {
      if (!window.sessionStorage) return;
      window.sessionStorage.setItem(cacheKey, JSON.stringify({
        savedAt: Date.now(),
        payload: payload
      }));
    } catch (e) {}
  }

  function initBadge(badge) {
    if (!badge || initializedBadges.has(badge)) return;
    initializedBadges.add(badge);

    var badgeId = badge.getAttribute('data-reviews-badge-id');
    var fallbackUrl = badge.getAttribute('data-reviews-badge-fallback-url') || '';
    var reviewsApiUrl = badge.getAttribute('data-reviews-badge-api-url') || '';
    var businessName = badge.getAttribute('data-reviews-badge-business-name') || 'Our Store';
    var storageKey = 'reviewsBadgeClosed_' + badgeId;
    var cacheKey = 'reviewsBadgePayload_' + badgeId;

    var closeBtn = badge.querySelector('.custom-reviews-badge__close');
    var badgeLink = badge.querySelector('[data-reviews-badge-open]');
    var badgeScoreEl = badge.querySelector('.custom-reviews-badge__score');
    var badgeTextEl = badge.querySelector('.custom-reviews-badge__text');
    var modal = document.querySelector('[data-reviews-badge-modal-id="' + badgeId + '"]');
    var loadingEl = modal ? modal.querySelector('[data-reviews-badge-loading]') : null;
    var errorEl = modal ? modal.querySelector('[data-reviews-badge-error]') : null;
    var summaryEl = modal ? modal.querySelector('[data-reviews-badge-summary]') : null;
    var listEl = modal ? modal.querySelector('[data-reviews-badge-list]') : null;
    var modalCloseButtons = modal ? modal.querySelectorAll('[data-reviews-badge-modal-close]') : [];
    var hasLoadedReviews = false;
    var isLoadingReviews = false;

    if (!badgeId || !closeBtn) return;

    try {
      if (window.localStorage.getItem(storageKey) === '1') {
        badge.style.display = 'none';
        return;
      }
    } catch (e) {}

    function closeModal() {
      if (!modal) return;
      modal.setAttribute('hidden', 'hidden');
      document.body.classList.remove('reviews-badge-modal-open');
    }

    function openModal() {
      if (!modal) return;
      modal.removeAttribute('hidden');
      document.body.classList.add('reviews-badge-modal-open');
    }

    function showFallbackError() {
      if (!errorEl) return;
      errorEl.innerHTML =
        'Unable to load live reviews. <a href="' + fallbackUrl + '" target="_blank" rel="noopener noreferrer">Open Google reviews</a>.';
      setHidden(loadingEl, true);
      setHidden(summaryEl, true);
      setHidden(listEl, true);
      setHidden(errorEl, false);
      openModal();
    }

    function renderReviews(payload) {
      var data = extractReviewsPayload(payload);
      var reviews = data.reviews || [];
      var avg = data.rating || data.average_rating || (badgeScoreEl ? badgeScoreEl.textContent : '0');
      var total = data.user_ratings_total || data.total_reviews || reviews.length;

      if (badgeScoreEl) {
        var numericAvg = Number(avg);
        badgeScoreEl.textContent = Number.isFinite(numericAvg) ? numericAvg.toFixed(1) : String(avg);
      }
      if (badgeTextEl && total) {
        badgeTextEl.textContent = 'Based on ' + formatCount(total) + ' reviews';
      }

      if (!reviews.length) {
        showFallbackError();
        return;
      }

      if (summaryEl) {
        summaryEl.innerHTML =
          '<strong class="custom-reviews-badge-modal__business-name">' + escapeHtml(businessName) + '</strong>' +
          '<div class="custom-reviews-badge-modal__summary-row">' +
          '<strong class="custom-reviews-badge-modal__summary-score">' + escapeHtml(avg) + '</strong>' +
          '<span class="custom-reviews-badge-modal__summary-stars">' + escapeHtml(renderStars(avg)) + '</span>' +
          '<span class="custom-reviews-badge-modal__summary-count">(' + escapeHtml(formatCount(total)) + ' reviews)</span>' +
          '</div>';
      }

      if (listEl) {
        listEl.innerHTML = reviews.slice(0, 10).map(function (review) {
          var author = review.author_name || review.author || 'Google User';
          var rating = review.rating || 0;
          var text = review.text || review.comment || '';
          var when = review.relative_time_description || review.date || '';
          return '<article class="custom-reviews-badge-modal__item">' +
            '<header class="custom-reviews-badge-modal__item-head"><strong>' + escapeHtml(author) +
            '</strong><span class="custom-reviews-badge-modal__item-stars">' + escapeHtml(renderStars(rating)) +
            '</span></header>' + (text ? '<p>' + escapeHtml(text) + '</p>' : '') +
            (when ? '<small>' + escapeHtml(when) + '</small>' : '') + '</article>';
        }).join('');
      }

      setHidden(loadingEl, true);
      setHidden(errorEl, true);
      setHidden(summaryEl, false);
      setHidden(listEl, false);
      openModal();
    }

    function loadReviews() {
      if (!reviewsApiUrl) {
        showFallbackError();
        return;
      }
      var cachedPayload = readCachedPayload(cacheKey);
      if (cachedPayload) {
        hasLoadedReviews = true;
        renderReviews(cachedPayload);
        return;
      }
      if (hasLoadedReviews) {
        openModal();
        return;
      }
      if (isLoadingReviews) return;

      isLoadingReviews = true;
      hasLoadedReviews = true;
      setHidden(loadingEl, false);
      setHidden(errorEl, true);
      fetch(reviewsApiUrl, { credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to fetch');
          return response.json();
        })
        .then(function (payload) {
          writeCachedPayload(cacheKey, payload);
          renderReviews(payload);
        })
        .catch(showFallbackError)
        .finally(function () {
          isLoadingReviews = false;
        });
    }

    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      badge.style.display = 'none';
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (e) {}
    });

    if (badgeLink && modal) {
      badgeLink.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        loadReviews();
      });
    }

    for (var i = 0; i < modalCloseButtons.length; i++) {
      modalCloseButtons[i].addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  function initAllBadges() {
    var badges = document.querySelectorAll('[data-reviews-badge-id]');
    for (var i = 0; i < badges.length; i++) {
      initBadge(badges[i]);
    }
  }

  /**
   * iOS Safari: when the bottom/URL chrome shows or hides, the layout viewport
   * and visual viewport get out of sync. Pin the fixed badge to the visual
   * viewport bottom by setting this offset (see reviews-badge.css).
   */
  function syncReviewsBadgeVisualViewportInset() {
    var vv = window.visualViewport;
    if (!vv) return;
    var gap = window.innerHeight - vv.offsetTop - vv.height;
    var px = Math.max(0, Math.round(gap * 1000) / 1000) + 'px';
    document.documentElement.style.setProperty('--reviews-badge-vv-inset', px);
  }

  function bindVisualViewportBadgeSync() {
    if (!window.visualViewport) return;
    var handler = function () {
      syncReviewsBadgeVisualViewportInset();
    };
    window.visualViewport.addEventListener('resize', handler, { passive: true });
    window.visualViewport.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler, { passive: true });
    handler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindVisualViewportBadgeSync();
      initAllBadges();
    });
  } else {
    bindVisualViewportBadgeSync();
    initAllBadges();
  }
})();
